import { SET_PAYPAL_ONCLICK_SESSION, RESET_PAYPAL_ONCLICK_SESSION } from '../actionTypes';

const initialState = null;

export default function paypalOneClickSession(state = initialState, action) {
    switch (action.type) {
        case SET_PAYPAL_ONCLICK_SESSION:
            return {
                ...state,
                paypalOneClickSessionId: action.payload.paypalOneClickSessionId
            };
        case RESET_PAYPAL_ONCLICK_SESSION:
            return {
                ...state,
                paypalOneClickSessionId: null
            }
        default:
            return state;
    }
}
